import { Menu } from 'antd';
import { MenuItemType } from 'antd/es/menu/hooks/useItems';
import { useMenuList } from 'constants/menu';
import React, { useEffect, useState } from 'react';
import { To, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import Routers from 'constants/routers';

function TCommonSidebar() {
  const { user } = useAuth();
  const userRole = user?.role;
  const menuList = useMenuList();
  const navi = useNavigate();
  const location = useLocation();
  const [defaultSelectedKeys, setDefautSelectedKeys] = useState<string>(location.pathname);

  const getHomePageByRole = () => {
    switch (userRole) {
      case 'leader':
      case 'board_of_directors':
      case 'chief_operating_officer':
        return Routers.Candidates;
      default:
        return Routers.Jobs;
    }
  }

  const filterMenuByRole = () => {
    switch (userRole) {
      case 'admin':
        return menuList;

      case 'human_resource':
        return menuList.filter((item) =>
          [
            '/job-management',
            '/articles-management',
            '/candidates-management',
            '/user-management',
            '/marathon-event',
            '/infomation',
            '/bod-interview-management',
            '/training-management',
            '/hashtag-management',
            '/test-management'
          ].includes(item.key)
        );

      case 'training_coordinator':
        return menuList.filter((item) => ['/training-management', '/hashtag-management'].includes(item.key));

      case 'leader':
        return menuList.filter((item) => ['/candidates-management', '/test-management'].includes(item.key));
      case 'board_of_directors':
      case 'chief_operating_officer':
        return menuList.filter((item) => ['/job-management','/candidates-management', '/bod-interview-management','/test-management'].includes(item.key));

      default:
        return [];
    }
  };

  const roleBasedMenu = filterMenuByRole().map(item => ({
    ...item,
    icon: React.cloneElement(
      item.icon,
      {
        color: item.key === defaultSelectedKeys ? '#D7242F' : '#666666' // Đỏ khi active, xám khi thường
      }
    )
  }));

  const onSelect = (item: MenuItemType) => {
    navi(item.key as To);
  };

  useEffect(() => {
    setDefautSelectedKeys(location.pathname);
  }, [location.pathname]);

  return (
    <>
      <div
        className="header__logo cursor-pointer"
        onClick={() => navi(`${getHomePageByRole()}`)}
        tabIndex={0}
      />
      <Menu theme="dark" mode="inline" selectedKeys={[defaultSelectedKeys]} onSelect={onSelect} items={roleBasedMenu} />
    </>
  );
}

export default TCommonSidebar;